import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { StyledColumnHeader, StyledSortArrow } from './ColumnHeader.styles';

import ArrowTopIcon from '../../../../assets/v2/ArrowTopIcon';
import ArrowBottomIcon from '../../../../assets/v2/ArrowBottomIcon';
import ColumnSort, { SORTING_TYPES } from './ColumnSort';

export const ColumnHeader = ({ sortBy, setSortBy, children, column }) => {
  const [menuAnchor, setMenuAnchor] = useState();
  const isMenuOpen = Boolean(menuAnchor);
  const [value] = sortBy;

  const handleOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleClose = () => {
    setMenuAnchor(null);
  };

  return (
    <>
      <StyledColumnHeader
        onClick={column.Sort && handleOpen}
        isOpen={isMenuOpen}
      >
        {children}
        {column.Sort && (
          <StyledSortArrow>
            {isMenuOpen ? <ArrowTopIcon /> : <ArrowBottomIcon />}
          </StyledSortArrow>
        )}
      </StyledColumnHeader>
      {column.Sort && (
        <ColumnSort
          value={value}
          handleOpen={handleOpen}
          handleClose={handleClose}
          setSortBy={setSortBy}
          menuAnchor={menuAnchor}
          isMenuOpen={isMenuOpen}
          column={column}
          type={column.Sort.type || SORTING_TYPES.SIMPLE}
        />
      )}
    </>
  );
};

ColumnHeader.propTypes = {
  sortBy: PropTypes.array,
  setSortBy: PropTypes.func,
  children: PropTypes.node,
  column: PropTypes.object,
};
